export default __webpack_public_path__ + "static/media/Scenery02.3ac0f5ff.jpg";